import React, { FC } from 'react';

import { isWidthUp, TableCell } from '@material-ui/core';
import cx from 'classnames';

import { ProgressLine } from '../../../../../components/UI/ProgressLine';
import { useWidth } from '../../../../../theme';
import { CellProps } from '../../../const';

const ProgressCell: FC<CellProps> = ({ row, k, styles, align }) => {
  const progress = row[k] ? Math.max(row[k]) : 0;

  const width = useWidth();
  const isMobile = !isWidthUp('sm', width);

  return (
    <TableCell key={k} className={styles.contentCell} align={align} title={`${progress}`}>
      <div className={styles.progressCellWrapper}>
        {!isMobile && (
          <div className={styles.progressWrapper}>
            <ProgressLine
              wrapperClass={styles.progressLineWrapper}
              lineClass={styles.progressLine}
              width={progress}
            />
          </div>
        )}
        <div className={cx(styles.progressValueWrapper, styles.notStarted)}>{progress}%</div>
      </div>
    </TableCell>
  );
};

export default ProgressCell;
